import { Component, Input } from '@angular/core';
import { Field } from '@sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { FormService } from '../../../common/services/form.service';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { OutlookUserService } from '../../../common/services/outlook-user.service';
import { FormCommonDataService } from '../../../common/services/form-common-data.service';
import { SimpleCommunityWithOpenTicketsCount } from '@sb-tools/typescript/models/simple-community-with-open-tickets-count.model';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { SelectAccessibilityDirective } from '@form-field-module/common/directives/select-accessibility.directive';
import { FormFieldLabelComponent } from '@form-field-module/common/components/form-field-label/form-field-label.component';

@Component({
    selector: 'sb-community-selector',
    templateUrl: './community-selector.component.html',
    styleUrls: ['./community-selector.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [TranslateModule, NgSelectModule, SelectAccessibilityDirective, FormsModule, FormFieldLabelComponent],
})
export class CommunitySelectorComponent {
    @Input() formField: Field | ClientField;

    constructor(
        public formService: FormService,
        public outlookUserService: OutlookUserService,
        private formCommonDataService: FormCommonDataService,
    ) {}

    onSelectCommunity(value: SimpleCommunityWithOpenTicketsCount): void {
        this.formCommonDataService.community = value?.communityName || null;
        this.formCommonDataService.updateCommunityName(this.formCommonDataService.community);
    }
}
